import {Injectable} from "@angular/core";
import {World} from "@core/world";
import {Kingdom} from "@core/kingdom";
import {Area} from "@core/area";
import {ParkProvider} from "@providers/park.provider";
import {WorldsKingdomsLands} from "@core/park/worldsKingdomsLands";
import {RefreshEvent} from "@events/RefreshEvent";


@Injectable()
export class ParkService {
  private parkPromise: Promise<WorldsKingdomsLands>;
  private allAreasPromise: Promise<Area[]>;

  constructor(private park: ParkProvider, private refresher: RefreshEvent) {
    this.refresher.on().subscribe(data => {
      if (data == "refresh.lands") {
        this.reloadParkDataLazy();
        this.reloadAllAreasLazy();
      }
    });
  }

  reloadParkDataLazy(){
    this.parkPromise = undefined;
  }

  reloadAllAreasLazy(){
    this.allAreasPromise = undefined;
  }

  addWorldAndKingdomToArea(area: any, worldMap: Map<string, World>, kingdomMap: Map<string, Kingdom>) {
    if (area && area.areaId) {
      const areaId = area.areaId;
      const segments = areaId.split('-');
      if (segments.length < 3) {
        console.log('Invalid areaId: ' + area.areaId);
      }
      const worldId = segments[0];
      const kingdomId = segments[1];

      area.worldId = worldId;
      area.world = worldMap.get(worldId) ? worldMap.get(worldId).name : worldId;
      area.kingdomId = kingdomId;
      area.kingdom = kingdomMap.get(kingdomId) ? kingdomMap.get(kingdomId).name : kingdomId;
      area.area = area.name;
    }

    return area;
  }

  async reloadWorldsKingdomsLands(): Promise<WorldsKingdomsLands> {
    return this.parkPromise = this.buildWorldsKingdomsLands();
  }

  async getWorldsKingdomsLands(): Promise<WorldsKingdomsLands> {
    if (this.parkPromise) {
      return this.parkPromise;
    } else {
      return this.parkPromise = this.buildWorldsKingdomsLands();
    }
  }

  async buildWorldsKingdomsLands() {
    let worldsKingdomsLands: WorldsKingdomsLands = new WorldsKingdomsLands();

    worldsKingdomsLands.worlds = await this.park.getWorlds() as Array<World>;

    // assign the worlds and kingdoms to a map
    worldsKingdomsLands.worlds.forEach(world => {
      worldsKingdomsLands.worldMap.set(world.worldId, world);
      let kingdoms = world.kingdoms;
      if (kingdoms) {
        kingdoms.forEach(kingdom => {
          worldsKingdomsLands.kingdomMap.set(kingdom.kingdomId, kingdom);
        });
      }
    });

    let areas: Area[] = await this.getAllAreas();

    // add worldId and kingdom id to the area
    // also assign area to kingdom
    worldsKingdomsLands.areas = areas.map(area => {
      let newArea = this.addWorldAndKingdomToArea(area, worldsKingdomsLands.worldMap, worldsKingdomsLands.kingdomMap);

      // assign area to areaId
      worldsKingdomsLands.areaMap.set(newArea.areaId, newArea);

      // assign area to kingdom
      let kingdom = worldsKingdomsLands.kingdomMap.get(newArea.kingdomId);
      if (kingdom) {
        if (!kingdom.lands) {
          kingdom.lands = [];
        }
        kingdom.lands.push(newArea);
      }

      return newArea;
    });

    return worldsKingdomsLands;
  }

  async getAllAreas(): Promise<Area[]> {
    if (this.allAreasPromise) {
      return this.allAreasPromise;
    } else {
      return this.allAreasPromise = this.park.searchAreas(false) as Promise<any[]>;
    }
  }

  getAreaById(areaId) {
    return this.getWorldsKingdomsLands()
      .then(worldsKingdomsLands => {
        return worldsKingdomsLands.areaMap.get(areaId);
      });
  }

  getKingdomById(kingdomId) {
    return this.getWorldsKingdomsLands()
      .then(worldsKingdomsLands => {
        return worldsKingdomsLands.kingdomMap.get(kingdomId);
      });
  }

  getNamesByArea(options: any = {}): Promise<any> {
    return this.getAreaById(options.areaId);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/park/park.service.ts